import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../layouts/DefaultLayout";
import { withRouter } from "react-router-dom";
import { Button, Card, Col, Input, Row, Table } from "antd";
import { debounce } from "lodash";
import { defaultCurrencyFormat } from "../../../utilities";
import EditableTableCell from "../../table/EditableTableCell";
import claimStatuses from "../../../configs/claim-statuses";

/**
 * Shows claims for quotes.
 */
@inject("context")
@withRouter
@observer
class Claims extends Component {
	state = {
		filteredInfo: null,
	};
	componentDidMount() {
		this.reloadClaims();
	}

	render() {
		const service = this.props.context.claimsService;
		let { filteredInfo } = this.state;
		filteredInfo = filteredInfo || {};
		const filterClaimStatuses = Object.keys(claimStatuses).map(function (key) {
			return {
				text: key,
				value: key,
			};
		});

		const columns = [
			{
				title: "Renewal date",
				dataIndex: "renewalDate",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "Policy number",
				dataIndex: "policyNumber",
				sorter: true,
			},
			{
				title: "Insurer",
				dataIndex: "insurer",
				sorter: true,
			},
			{
				title: "Product",
				dataIndex: "product",
				sorter: true,
			},
			{
				title: "First name",
				dataIndex: "firstName",
			},
			{
				title: "Last name",
				dataIndex: "lastName",
				sorter: true,
			},
			{
				title: "Phone number",
				dataIndex: "phoneNumber",
			},
			{
				title: "Address 1",
				dataIndex: "address1",
			},
			{
				title: "Address 2",
				dataIndex: "address2",
			},
			{
				title: "City",
				dataIndex: "city",
			},
			{
				title: "Postcode",
				dataIndex: "post_code",
			},
			{
				title: "Total claimed",
				dataIndex: "totalClaimed",
				render: (n) => {
					return defaultCurrencyFormat(n);
				},
			},
			{
				title: "Actions",
				render: (field, record) => {
					return (
						<Button
							type="primary"
							onClick={() => this.handleEditClaimButtonClick(record)}
						>
							Edit Claim
						</Button>
					);
				},
			},
			{
				title: "Notes",
				dataIndex: "notes",
				width: "30%",
				render: (notes, record) => {
					return (
						<EditableTableCell
							recordId={record.quoteId}
							handleSave={this.handleSaveQuoteNotesClick}
							value={notes}
						/>
					);
				},
			},
			{
				title: "Unread messages",
				dataIndex: "messages",
				width: "30%",
				render: (messages) => {
					return (
						messages.filter(m => m.isMsgRead === false).length
					);
				},
			},
			{
				title: "Claim status",
				dataIndex: "status",
				sorter: true,
				filters: filterClaimStatuses,
				filteredValue: filteredInfo.status || null,
				onFilter: (value, record) => record.status.includes(value),
			},
		];

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 40,
						paddingRight: 40,
					},
				}}
			>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Claims</h1>}>
							<Row>
								<Col
									xs={6}
									style={{
										paddingBottom: "15px",
									}}
								>
									<Input.Search
										onSearch={this.handleSearchChange}
										onChange={this.handleSearchChange}
										value={service.search.value}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<Table
										rowKey="quoteId"
										columns={columns}
										dataSource={service.claimsData}
										pagination={service.pagination}
										loading={service.loading}
										onChange={this.handleTableChange}
									/>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleTableChange = (pagination, filters, sorter) => {
		const service = this.props.context.claimsService;
		this.setState({
			filteredInfo: filters,
		});

		service.setPagination(pagination);
		service.setSorter(sorter);

		service.loadClaimsData();
	};

	handleSearchChange = (...args) => {
		const value =
			args.length === 2
				? args[1].currentTarget.value
				: args[0].currentTarget.value;

		this.props.context.claimsService.setSearch({
			fields: [
				"policyNumber",
				"organisation.last_name",
				"organisation.postcode",
				"organisation.phone",
			],
			value,
		});

		this.debouncedReloadItems();
	};

	handleEditClaimButtonClick = async (record) => {
		const { claimId } = record;

		if (claimId)
			this.props.history.push({ pathname: `claims/${claimId}`, data: record });
	};

	handleSaveQuoteNotesClick = async (quoteId, notes) => {
		await this.props.context.claimsService.saveQuoteNotes(quoteId, notes);
		this.reloadClaims();
	};

	reloadClaims = async () => {
		await this.props.context.claimsService.loadClaimsData();
	};

	debouncedReloadItems = debounce(this.reloadClaims, 250);
}

export default Claims;
